const Support = {
  getSupport: {
    url: "/query",
    method: "GET",
  },
  reply: (id) => ({
    url: `/query/${id}/reply`,
    method: "PATCH",
  }),
};
export default Support;
